import {
  Box,
  Button,
  ButtonProps,
  Typography
} from '@mui/material';
import {
  appFormUtil,
  authUtil
} from 'modules/common';
import {
  BaseFormLayout,
  StyledInputTextField
} from 'modules/components';
import {
  useCallback,
  useState
} from 'react';
import { useNavigate } from 'react-router-dom';
import * as ds from './dataService';



export type IFormState = {
  email: string;
  password: string;
};



export type LoginProps = {
  handleForgotPassword: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: LoginProps) => {
  const navigate = useNavigate();
  const {
    formState,
    genFieldProps
  } = appFormUtil.useFormState({
    initialState: {
      email: '',
      password: ''
    },
    key2FieldConfig: {
      email: {
        label: 'Email',
        type: 'email',
        fnValidate: (e) => {
          if (typeof e === 'string') {
            if (e.length < 2) {
              return '';
            }
            if (e.length > 4 && e.includes('@')) {
              return '';
            } else {
              return 'Please enter valid email';
            }
          } else {
            return '';
          }
        }
      },
      password: {
        label: 'Password',
        type: 'password'
      }
    }
  });



  const [
    err,
    setErr
  ] = useState('');
  const [fnGetLoggedInUser] = ds.useGetLoggedInUser();



  const handleLogin = useCallback(async () => {
    await authUtil.signIn(formState.email, formState.password);
    await fnGetLoggedInUser();
  }, [
    fnGetLoggedInUser,
    formState
  ]);



  return (
    <BaseFormLayout.FC
      title='Welcome to Sherlock'
      subTitle='Enter your login information to continue'
      cancelButton={(
        <>
          <Button
            size='small'
            variant='outlined'
            color='primary'
            fullWidth
            onClick={() => {
              props.handleForgotPassword();
            }}
          >
            Forgot Password
          </Button>

          <Button
            variant='text'
            sx={{
              color: (theme) => theme.palette.gray.dark
            }}
            onClick={() => navigate('/auth/register', {
              replace: true
            })}
          >
            Need an account?
            <Box
              component='span'
              sx={{
                ml: 1,
                color: (theme) => theme.palette.primary.main
              }}
            >
              Register here.
            </Box>
          </Button>
        </>
      )}
      nextButton={(
        <LoginButton
          onClick={async () => {
            try {
              setErr('');
              await handleLogin();

            } catch (err) {
              if (err instanceof Error) {
                setErr(err.message);
              }
            }
          }}
        />
      )}
    >
      {err && (
        <Typography
          variant='body2'
          color='error'
        >
          {err}
        </Typography>
      )}

      <StyledInputTextField.FC
        {...genFieldProps('email')}
      />

      <StyledInputTextField.FC
        {...genFieldProps('password')}
      />
    </BaseFormLayout.FC>
  );
};



const LoginButton = (props: ButtonProps) => {
  return (
    <Button
      onClick={props.onClick}
      variant='contained'
      color='primary'
      type='submit'
      fullWidth
    >
      Login
    </Button>
  );
};
